import styled from "styled-components";

export const ContentTextWrapper = styled.div`
  background-color: var(--fd-colors-background-base);
`;

export const TextContainer = styled.div<{ isCPP: boolean; isMobile: boolean }>`
  background-color: var(--fd-colors-background-surface);
  padding: var(--fd-space-space-4);
  line-height: var(--fd-line-heights-line-height-030);
  border-radius: ${({ isCPP, isMobile }) => {
    // TODO - If PMA promos fields are updated and we have a title field to pull data from,
    // TODO - we will need to update this isCPP logic
    if (isMobile) return "0";
    if (isCPP) return "var(--fd-radii-border-radius-020)";
    return "0 0 var(--fd-radii-border-radius-020) var(--fd-radii-border-radius-020)";
  }};
`;
